module.exports = __webpack_public_path__ + "static/totem-cd30cda53d50d9a56cbe6762c83aeb10.png";